import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../core/_services/authentication.service';
import { AlertasService } from '../../core/_services/alerta.service';
import { CoreService } from '../../core/_services/core.services';
import * as $ from 'jquery';
import { AppConfig } from '../app.config';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-login',
  templateUrl: './app.login.component.html',
  styleUrls: ['./app.login.component.scss']
})
export class AppLoginComponent implements OnInit {

  moduloPersonas: boolean = false;
  recuperarContrasena: boolean = false;
  mostrarRegistro: boolean = false;
  tipoContrasena: string = 'password';

  public loginData = { username: '', password: '', email: '' };


  constructor(
    private service: AuthenticationService,
    public coreService: CoreService,
    public msj: AlertasService,
    public spinner: NgxSpinnerService
  ) {
    this.loginData = { username: '', password: '', email: '' };
  }

  ngOnInit(): void {
    sessionStorage.clear();
  }

  login() {
    if (this.loginData.username === undefined || this.loginData.username === null || this.loginData.username === '') {
      this.msj.error('Usuario obligatorio.');
    } else if (this.loginData.password === undefined || this.loginData.password === null || this.loginData.password === '') {
      this.msj.error('Contraseña obligatoria.');
    } else {
      if (!this.moduloPersonas) {
        this.service.obtainAccessToken(this.loginData);
      } else {
        this.msj.info('login administrativo');
      }
    }
  }

  enter(event) {
    if (event.key === 'Enter') {
      this.login();
    }
  }

  cambioModulo() {
    this.moduloPersonas = !this.moduloPersonas;
  }

  labelModulo() {
    if (this.moduloPersonas) {
      return 'Ir a sección de candidato';
    } else {
      return 'Ir a sección administrativa';
    }
  }

  mostrarStack() {
    $('.fab').toggleClass('open');
  }

  clickRecuperar() {
    this.recuperarContrasena = !this.recuperarContrasena;
  }

  clickRegistro() {
    this.mostrarRegistro = true;
  }

  clickInicio() {
    this.mostrarRegistro = false;
    this.recuperarContrasena = false;
  }

  enviarCorreoRecuperacion() {
    if (this.loginData.email === undefined || this.loginData.email === null || this.loginData.email === '') {
      this.msj.error('El correo electrónico es obligatorio.');
    } else {
      let data = {
        email: this.loginData.email,
      }
      this.coreService.post('/recuperar-contrasena', data).subscribe(
        (res: any[]) => {
          this.msj.info(res);
        },
        (err: any) => {
          this.msj.error('ERROR: ' + err);
        }
      )
    }
  }

  clickAdministrativo() {
    let rutaRedireccion = AppConfig.settings.apiServer.URL_ENLACE_LOGIN;
    if (rutaRedireccion !== null && rutaRedireccion !== undefined && rutaRedireccion !== '') {
      window.location.href = rutaRedireccion;
    } else {
      this.msj.alerta('No está configurada una ruta para la redirección.');
    }
  }

  mostrarContrasena() {
    if (this.tipoContrasena === 'password') {
      this.tipoContrasena = 'text';
    } else {
      this.tipoContrasena = 'password';
    }
  }

}
